var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Whatsapp",
    transform: "translate(-1177 -7168)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Surface",
    width: 44,
    height: 44,
    rx: 22,
    transform: "translate(1177 7168)",
    fill: "#128c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-whatsapp",
    d: "M19.077,4.928A9.99,9.99,0,0,0,3.355,16.977L2,22l5.233-1.237a9.98,9.98,0,0,0,4.773,1.216h0A9.991,9.991,0,0,0,19.077,4.928ZM16.9,15.554a2.517,2.517,0,0,1-1.685,1.186c-.458.042-.887.207-2.995-.624a10.236,10.236,0,0,1-4.263-3.767A4.853,4.853,0,0,1,6.936,9.768,2.794,2.794,0,0,1,7.81,7.687a.916.916,0,0,1,.666-.312c.166,0,.333,0,.478.006.178.007.375.016.562.431.222.494.707,1.728.769,1.853a.461.461,0,0,1,.021.437,1.732,1.732,0,0,1-.249.416c-.125.146-.262.325-.374.437s-.255.26-.11.509a7.508,7.508,0,0,0,1.388,1.728,6.856,6.856,0,0,0,2.007,1.239c.25.125.4.1.541-.063s.624-.728.79-.978.333-.208.562-.125,1.456.687,1.705.812.416.187.478.291A2.089,2.089,0,0,1,16.9,15.554Z",
    transform: "translate(1187 7178)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappRounded);
export default __webpack_public_path__ + "static/media/WhatsappRounded.d73ff70a0da22423a1ccaef6ed127b17.svg";
export { ForwardRef as ReactComponent };